import { SecondaryNavigation } from '@app/shared/components/secondary-navigation/SecondaryNavigation';
import {
  SecondaryNavigationItemVariation,
  SecondaryNavigationVariation,
} from '@app/shared/components/secondary-navigation/secondary-navigation-enums';
import { NavigationItem } from '@app/shared/components/secondary-navigation/secondary-navigation-types';
import { useLocale } from '@app/core/hooks/useLocale';
import { RouteConstants } from '@app/modules/projects/RouteConstants';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { enumKeyByValue } from '@app/shared/helpers';
import { CalcMethod } from '@app/shared/models/contracts/enums/shared-enums';
import { useFocusMode } from '@app/shared/hooks/focus-mode';
import { useSearchParams } from 'react-router-dom';
import { SearchParamKey } from '@app/shared/models/search-param-enum';

export const SponsorIRRAndHurdleNavigation = () => {
  const { l } = useLocale();
  const { isActive, focusType } = useFocusMode();
  const [searchParams] = useSearchParams();
  const hasFocusParams = Boolean(searchParams.get(SearchParamKey.FocusType));
  const projectCalcMethod = useAppSelector(
    (state) => state.project.projectDraft.details.calcMethod
  );
  const isOpm = projectCalcMethod === enumKeyByValue(CalcMethod, CalcMethod.OPM);

  const navigationItems: NavigationItem[] = [
    !isOpm && {
      label: l('_SponsorIRR'),
      route: `../${RouteConstants.SponsorIRR}`,
      variation: SecondaryNavigationItemVariation.NoTrim,
      preserveSearch: hasFocusParams,
    },
    {
      label: l('_IRRHurdleCalculations'),
      route: `../${RouteConstants.IRRHurdleCalculations}`,
      variation: SecondaryNavigationItemVariation.NoTrim,
      preserveSearch: hasFocusParams,
    },
  ].filter(Boolean) as NavigationItem[];

  return (
    <div>
      <SecondaryNavigation
        navigationItems={navigationItems}
        variation={SecondaryNavigationVariation.Scrollable}
        focusModeType={isActive ? focusType : undefined}
      />
    </div>
  );
};
